module.exports = __webpack_public_path__ + "img/qr-code.a5ba3c0e.jpeg";